export function walk(obj, path, defaultValue) {
    let paths = path.split('.')
        , current = obj
        , i;

    for (i = 0; i < paths.length; ++i) {
        if (!current || current[paths[i]] == undefined) {
            return defaultValue;
        } else {
            current = current[paths[i]];
        }
    }
    return current;
}
